import { useDataValue, useDataChange, DataProvider } from 'Simple/Data.js'
import ActionsAction from './ActionsAction/view.js'
import SelectAction from './SelectAction/view.js'
import SelectAllAction from './SelectAllAction/view.js'
import React, { useMemo } from 'react'

import View from './view.js'

export default function Logic(props) {
  let subscribers = useDataValue({
    context: 'subscribers',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    path: 'bulk_user_ids',
    viewPath: props.viewPath,
  })

  let value = useMemo(() => {
    let columns = [
      {
        id: 'select-col',
        header: ({ table }) => (
          <SelectAllAction
            value={table.getIsAllRowsSelected()}
            onChange={() =>
              table.toggleAllRowsSelected(!table.getIsAllRowsSelected())
            }
          />
        ),
        enableSorting: false,
        enableColumnFilter: false,
        accessorKey: 'select',
        cell: ({ cell, row }) => {
          return (
            <SelectAction
              viewPath={`${props.viewPath}/SelectAction(${cell.row.original.id})`}
              value={row.getIsSelected()}
              onChange={row.getToggleSelectedHandler()}
            />
          )
        },
      },
      {
        id: 'employee',
        header: 'Employee',
        accessorKey: 'employee_name',
      },
      {
        id: 'email',
        header: 'Email',
        accessorKey: 'employee_email',
      },
      {
        id: 'added',
        header: 'Added by & On',
        accessorKey: 'created_details',
      },
      {
        id: 'subscribed',
        header: 'Subscribed to',
        accessorKey: 'stages',
        cell: cell => {
          let stages = [...cell.getValue()]
          return (
            <div>
              {stages
                .sort((a, b) => a.order - b.order)
                .map(stage => stage.name)
                .join(', ')}
            </div>
          )
        },
      },
      {
        id: 'actions',
        header: 'Actions',
        accessorKey: 'created_details',
        cell: ({ cell, row }) => {
          return (
            <DataProvider
              context="subscriber"
              value={cell.row.original}
              viewPath={props.viewPath}
            >
              <ActionsAction
                viewPath={`${props.viewPath}/ActionsAction(${cell.row.original.id})`}
              />
            </DataProvider>
          )
        },
      },
    ].filter(Boolean)

    if (!subscribers) return { columns, data: [] }

    return {
      columns,
      data: subscribers,
    }
  }, [subscribers]) //eslint-disable-line

  function onChange(table) {
    let selected = table.getSelectedRowModel().rows.map(r => r.original.id)
    change(selected)
  }

  return <View value={value} onChange={onChange} viewPath={props.viewPath} />
}
